import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";
import { FormField } from "@/components/forms/FormField";

const PlanEditor = ({ plan, onSaved }) => {
  const [f, setF] = useState({ ...plan, features: plan.features.join("\n") });
  const [saving, setSaving] = useState(false);
  const id = `plan-${plan.plan_id}`;
  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`/admin/plans/${plan.plan_id}`, {
        name: f.name, price_month: Number(f.price_month), description: f.description, features: f.features.split("\n"), active: f.active,
      });
      onSaved(data);
      toast.success(`Piano ${data.name} salvato`);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setSaving(false);
    }
  };
  return (
    <div className="space-y-4 rounded-2xl border border-[#E2E5DC] bg-white p-5" data-testid={`${id}-editor`}>
      <div className="grid grid-cols-2 gap-3">
        <FormField id={`${id}-name`} label="Nome"><Input id={`${id}-name`} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid={`${id}-name-input`} /></FormField>
        <FormField id={`${id}-price`} label="€ / mese + IVA"><Input id={`${id}-price`} type="number" min="0" step="0.01" value={f.price_month} onChange={(e) => setF({ ...f, price_month: e.target.value })} data-testid={`${id}-price-input`} /></FormField>
      </div>
      <FormField id={`${id}-desc`} label="Descrizione"><Textarea id={`${id}-desc`} rows={2} value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} data-testid={`${id}-description-input`} /></FormField>
      <FormField id={`${id}-feat`} label="Cosa include (una voce per riga)"><Textarea id={`${id}-feat`} rows={4} value={f.features} onChange={(e) => setF({ ...f, features: e.target.value })} data-testid={`${id}-features-input`} /></FormField>
      <div className="flex items-center justify-between">
        <label className="flex items-center gap-2 text-sm"><Switch checked={f.active} onCheckedChange={(v) => setF({ ...f, active: v })} data-testid={`${id}-active-switch`} /> Visibile</label>
        <Button onClick={save} disabled={saving} className="rounded-full bg-[#0F2D5E] hover:bg-[#0B2250]" data-testid={`${id}-save-btn`}>
          {saving ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Save className="mr-2 h-4 w-4" />} Salva
        </Button>
      </div>
    </div>
  );
};

export const AdminPlans = () => {
  const [plans, setPlans] = useState([]);
  useEffect(() => { api.get("/admin/plans").then((r) => setPlans(r.data)); }, []);
  const saved = (p) => setPlans((ps) => ps.map((x) => (x.plan_id === p.plan_id ? p : x)));
  return (
    <section data-testid="admin-plans">
      <h2 className="text-2xl font-bold">Piani aziende</h2>
      <p className="mt-1 text-sm text-[#495850]">Prezzi provvisori: le modifiche si vedono subito nel modulo di registrazione aziende.</p>
      <div className="mt-6 grid gap-4 lg:grid-cols-3">{plans.map((p) => <PlanEditor key={p.plan_id} plan={p} onSaved={saved} />)}</div>
    </section>
  );
};
